import { render, staticRenderFns } from "./tikuconfig.vue?vue&type=template&id=bf76cd2c&scoped=true&"
import script from "./tikuconfig.vue?vue&type=script&lang=js&"
export * from "./tikuconfig.vue?vue&type=script&lang=js&"
import style0 from "./tikuconfig.vue?vue&type=style&index=0&id=bf76cd2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf76cd2c",
  null
  
)

export default component.exports